import { DataTypeProvider } from '@devexpress/dx-react-grid';
import Tooltip from '@mui/material/Tooltip';
import NRInformationModal from '../../NRInformationModal/NRInformationModal';
import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import CorrelationsProviderStyles from './CorrelationsProvider.styles';
import makeStyles from '@mui/styles/makeStyles';
import NRSecondaryLink from '../../NRSecondaryLink/NRSecondaryLink';
import CorrelationsGrid from './CorrelationsGrid/CorrelationsGrid';
import { numberFilterOperations } from '../../NRReactGrid/NRReactGrid.utils';
import Box from '@mui/material/Box';
const useStyles = makeStyles(CorrelationsProviderStyles);

const EnhancedCorrelationsFormatter = ({ value, column, row }) => {
  const valueToUse = Array.isArray(value) ? value.length : value;
  const [open, setOpen] = useState(false);
  const classes = useStyles();
  return (
    <>
      <Tooltip title={valueToUse > 0 ? column.tooltipA + valueToUse + column.tooltipB : ''}>
        <NRSecondaryLink
          value={valueToUse}
          handleOnClick={() => setOpen(true)}
          openNull={false}
          aria-label={`Correlations: ${valueToUse}. Opens correlation report.`}
        />
      </Tooltip>
      <NRInformationModal
        width={'60vw'}
        isOpen={open}
        setIsOpen={setOpen}
        maxWidth={'65vw'}
        maxHeight={'80vh'}
        paperOverflow="auto"
        paddingContainer={0}
        showCancelButton={true}
      >
        <Box className={classes.titleContainer} pb={1.5}>
          <Typography variant="h3" component="span">
            {`${row?.title || 'Correlations'} - ${valueToUse}`}
          </Typography>
          <IconButton aria-label="Close" onClick={() => setOpen(false)} size="large">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <CorrelationsGrid setOpen={setOpen} rows={row?.correlations} />
      </NRInformationModal>
    </>
  );
};
export const EnhancedCorrelationsProvider = props => {
  return <DataTypeProvider formatterComponent={EnhancedCorrelationsFormatter} availableFilterOperations={numberFilterOperations} {...props} />;
};
